import {helpers} from "../reportingHelpers";

/**
 * ReportControlGroup contains controls grouped together.  These grouped controls can be acted upon collectively or by individual controls.
 * The primary purpose (as of now) is for these control groups to be able to support moving controls down when prior controls grow with content.
 */
export class ReportControlGroup {
    render(def, ctx, callback) {
        // Loop through each control and call their internal render function...EK

        let ctl = null;
        let ctlInx = 0;
        let outPDF = ctx.rootContext.pdf;

        var style = def.Style;
        if (style != null){
            if (style.borderWidth != null && style.borderWidth > 0){
                outPDF.setLineWidth(style.borderWidth);
                outPDF.setDrawColor(style.borderColor.r, style.borderColor.g, style.borderColor.b);

                if (style.background != null){
                    outPDF.setFillColor(style.background.r, style.background.g, style.background.b, null);
                }
                else {
                    outPDF.setFillColor(255, 255, 255, null);          //Default a border, but no background to white...EK
                }

                outPDF.roundedRect(helpers.getRenderLeft(def, ctx), helpers.getRenderTop(def, ctx), def.Width, def.Height, style.borderRadius, style.borderRadius, 'B');
            }
            else if (style.background != null){
                outPDF.setFillColor(style.background.r, style.background.g, style.background.b, null);
                outPDF.rect(helpers.getRenderLeft(def, ctx), helpers.getRenderTop(def, ctx), def.Width, def.Height, 'F');
            }
        }

        function renderControl(){
            ctl = def.Controls[ctlInx++];

            if (ctl == null){
                //We are done rendering all controls in this control group...EK
                callback();
            }
            else {
                ctx.activePageBreak = false;            // Make sure this flag is reset before each control that's rendered (it's handled in the control group's render when needed) ... EK
                ctx.renderingControl = ctl;
                //We have a control to render, attempt to get the internal render controller...EK
                let pdfCtl = ctx.controls[ctl.Type];
                if (pdfCtl == null){
                    console.warn(`No render defined for type: ${ctl.Type}`);
                    renderControl();
                }
                else{
                    try {
                        pdfCtl.render(ctl, ctx, renderControl);
                    }
                    catch (e){
                        console.error(`Error occurred while rendering report: ${e}`);
                        renderControl();
                    }
                }
            }
        }

        if (!def.Controls || !def.Controls.any()){
            callback();
        }
        else {
            renderControl();
        }
    }

    preRender(def, ctx, callback) {

        if (def.runTime == null){
            def.runTime = {
                top: def.Top,
                height: def.Height,
                totalGrowth: 0
            };
        }
        else {
            // Reset the top in case of growth layout changes...EK
            def.runTime.top = def.Top;
            def.runTime.height = def.Height;
            def.runTime.totalGrowth = 0;
        }

        // We are a pass though here to the controls within this control group.  The control group will control the layout organization so no additional logic is needed here...EK
        let ctlIndex = 0;
        let ctl = null;

        function preRenderCtl(){
            ctl = def.Controls[ctlIndex++];

            if (ctl == null){
                callback();
            }
            else {
                try {
                    ctx.controls[ctl.Type].preRender(ctl, ctx, preRenderCtl);
                }
                catch (e){
                    console.error(`Error pre-rendering type, check to see that you have a pre-render defined. Detail: ${e}`);
                    callback();
                }
            }
        }

        if (!def.Controls || !def.Controls.any()) {
            callback();
        }
        else {
            preRenderCtl();
        }
    }
}
